module.exports = __webpack_public_path__ + "85e827bc49af7cca54fed5c59ada4073.jpg";